import React from "react";
import { ResponsiveLine } from "@nivo/line";

const LineGraph = ({data, type, showDate}: {data: any, type: string, showDate: boolean}) => {
    const start = data[0].data[0].x;
    const end = data[0].data[data[0].data.length - 1].x;
    return(
        <>
            <ResponsiveLine 
                data={data}
                margin={{ top: 20, right: 30, bottom: 20, left: 20 }}
                xScale={type !== "cumulative" ? {type: "time", format: "%Y-%m-%d", precision: "day", useUTC: false} : {type: "linear"}}
                xFormat="time:%b %d"
                // yScale={{ type: "linear", min: 0, max: 10, stacked: true, reverse: false }}
                yFormat="^-.0f"
                axisTop={null}
                axisRight={null}
                enableGridX={false}
                enableGridY={false}
                axisBottom={type !== "cumulative" ? {
                    tickSize: 0,
                    tickPadding: 10,
                    tickRotation: 0,
                    tickValues: 0,
                    format: "%Y-%m-%d",
                } : {
                    tickSize: 0,
                    tickPadding: 10,
                    tickRotation: 0,
                    tickValues: 12,
                }}
                // axisLeft={{
                //     orient: 'left',
                //     tickSize: 0,
                //     tickPadding: 5,
                //     tickRotation: 0,
                //     legendOffset: -40,
                // }}
                axisLeft={null}
                pointSize={2}
                pointColor={{ from: "color", modifiers: [] }}
                pointBorderWidth={2}
                pointBorderColor={{ from: "color" }}
                // pointLabelYOffset={-12}
                useMesh={true}
                enableCrosshair={false}
            />
            {showDate &&
				<div style={{display: "flex", justifyContent: "space-between", fontSize: 12, padding: "0 10px 20px 20px"}}>
				    <p>{start}</p>
				    <p>{end}</p>
				</div>
            }
        </>
    );
};

export default LineGraph;